module.exports = __webpack_public_path__ + "img/bn.bn513d1e4.svg";